import React from 'react';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';
import { Smartphone, Download, ShieldCheck, Zap, WifiOff, Award } from 'lucide-react';

const GetTheApp = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-14 sm:pt-16">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-5 w-full space-y-3.5 sm:space-y-5">
        
        {/* Compact Hero Banner */}
        <div className="bg-gradient-to-r from-emerald-900 via-teal-900 to-gray-900 rounded-xl sm:rounded-2xl p-3.5 sm:py-4 sm:px-6 md:py-4 md:px-6 text-white shadow-xs flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="space-y-2 max-w-xl text-center sm:text-left">
            <span className="bg-emerald-500/30 text-emerald-300 border border-emerald-400/40 text-[9px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wider">
              Mobile Learning
            </span>
            <h1 className="text-sm sm:text-lg md:text-xl font-black leading-snug">
              Learn anytime, anywhere with E-Learning Hub Mobile App
            </h1>
            <p className="text-gray-300 text-[11px] sm:text-xs leading-snug">
              Download the official E-Learning Hub app on your smartphone or tablet. Download lectures offline, track progress, and earn certificates on the go.
            </p>
            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2 pt-0.5">
              <button className="bg-white text-gray-900 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg font-bold hover:bg-emerald-50 transition-colors flex items-center gap-2 shadow-xs cursor-pointer">
                <Smartphone className="text-emerald-600 w-4 h-4" />
                <div className="text-left">
                  <p className="text-[8px] text-gray-500 uppercase tracking-wider font-bold">GET IT ON</p>
                  <p className="text-[11px] sm:text-xs font-extrabold leading-none">Google Play</p>
                </div>
              </button>
              <button className="bg-white/10 backdrop-blur-md border border-white/20 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg font-bold hover:bg-white/20 transition-colors flex items-center gap-2 cursor-pointer">
                <Download className="w-4 h-4" />
                <div className="text-left">
                  <p className="text-[8px] text-gray-300 uppercase tracking-wider font-bold">Download on the</p>
                  <p className="text-[11px] sm:text-xs font-extrabold leading-none">App Store</p>
                </div>
              </button>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-lg border border-white/20 p-2.5 sm:p-3 rounded-xl text-center shrink-0 w-36 sm:w-44 space-y-1.5">
            <div className="w-24 h-24 sm:w-28 sm:h-28 mx-auto bg-white p-2 rounded-lg shadow-inner flex items-center justify-center">
              <img
                src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://learninghub.ind.in/get-the-app"
                alt="Scan to download app"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-[10px] text-gray-300 font-bold">Scan QR Code to Download</p>
          </div>
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <div className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs space-y-1">
            <WifiOff className="text-emerald-600" size={18} />
            <h3 className="font-bold text-gray-900 text-xs sm:text-sm">Offline Downloads</h3>
            <p className="text-[11px] text-gray-500 leading-normal">Download video lectures and PDFs to study without internet connection.</p>
          </div>
          <div className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs space-y-1">
            <Zap className="text-amber-500" size={18} />
            <h3 className="font-bold text-gray-900 text-xs sm:text-sm">Seamless Sync</h3>
            <p className="text-[11px] text-gray-500 leading-normal">Pick up right where you left off on web or mobile seamlessly.</p>
          </div>
          <div className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs space-y-1">
            <ShieldCheck className="text-blue-600" size={18} />
            <h3 className="font-bold text-gray-900 text-xs sm:text-sm">Secure Video Player</h3>
            <p className="text-[11px] text-gray-500 leading-normal">HD playback with playback speed controls (0.5x to 2.0x).</p>
          </div>
          <div className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs space-y-1">
            <Award className="text-purple-600" size={18} />
            <h3 className="font-bold text-gray-900 text-xs sm:text-sm">Instant Certificates</h3>
            <p className="text-[11px] text-gray-500 leading-normal">Download & share verified certificates directly from your phone.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default GetTheApp;
